import { render, staticRenderFns } from "./CharacterRoomArtPvp.vue?vue&type=template&id=b6bdf0c2&scoped=true&"
import script from "./CharacterRoomArtPvp.vue?vue&type=script&lang=js&"
export * from "./CharacterRoomArtPvp.vue?vue&type=script&lang=js&"
import style0 from "./CharacterRoomArtPvp.vue?vue&type=style&index=0&id=b6bdf0c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bdf0c2",
  null
  
)

export default component.exports